import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import style from './style.vue';

@Component({
  components: {},
  mixins: [style],
})
export default class HotStyle extends Vue {
  @Prop({ default: () => {} })
    value: ItemObject;

  render(h) {
    return (
      <div class="hot-style" style="background: none;">
        <div class="qiKan">
          <ul class={this.value.desc.qiKanShowType === 1 ? 'masonry' : 'big'}>
            <li class="first" />
            <li class="third" />
            <li class="second" />
            <li class="fourth" />
          </ul>
        </div>
      </div>
    );
  }
}
